import { render, staticRenderFns } from "./MediaLibraryBreadcrumbs.vue?vue&type=template&id=24309a19&"
import script from "./MediaLibraryBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./MediaLibraryBreadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24309a19')) {
      api.createRecord('24309a19', component.options)
    } else {
      api.reload('24309a19', component.options)
    }
    module.hot.accept("./MediaLibraryBreadcrumbs.vue?vue&type=template&id=24309a19&", function () {
      api.rerender('24309a19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/MediaLibrary/Components/MediaLibraryBreadcrumbs.vue"
export default component.exports